import { defineMessages } from 'react-intl'

export const lang = defineMessages({
  noOptions: {
    id: 'donater.payment_type.no_options_text',
    defaultMessage: 'No options are available for the current amount or currency.',
  },
})
